<div class="d-flex justify-content-between position-relative main-promotion-slider align-items-center mb-3"
    *ngIf="slides.length > 0">
    <h2 class="section-heading  mb-0">Promotions <span class="simple-font-family">({{slides?.length ? slides?.length :
            0}})</span></h2>
    <button class="view-all-new" (click)="allPromotions()"> View All</button>

</div>
<div id="promotionsDivScrollTarget">
    <ngx-slick-carousel class="carousel offer-slider" #slickModal="slick-carousel" [config]="slideConfig">
        <div ngxSlickItem *ngFor="let slide of slides;let i=index" class="slide">
            <a href="javascript:void(0);" (click)="viewPromotionsProducts('promotion/product/listing/',slide.rule_id)"
                *ngIf="slide?.is_selection_product == 1 &&  slide?.is_promotion_applied == 0">
                <img src="{{ slide.image}}" alt="" width="100%">
            </a>
            <a href="javascript:void(0);" (click)="viewPromotionsProducts('promotion/product/listing/',slide.rule_id)"
                *ngIf="slide?.is_selection_product == 0 || (slide?.is_selection_product == 1 && slide?.is_promotion_applied == 1)">
                <img src="{{ slide.image}}" alt="" width="100%">
            </a>

            <div class="button-bar">
                <button class="add-deal view-product-full"
                    (click)="viewPromotionsProducts('promotion/product/listing/',slide.rule_id)"
                    *ngIf="slide?.is_selection_product == 1"><a class="text-dark" href="javascript:void(0);"
                        (click)="viewPromotionsProducts('promotion/product/listing/',slide.rule_id)">View
                        Deal</a></button>

                <button class="view-product"
                    (click)="viewPromotionsProducts('promotion/product/listing/',slide.rule_id)"
                    *ngIf="slide?.is_selection_product == 0">
                    <a class="text-dark" href="javascript:void(0);"
                        (click)="viewPromotionsProducts('promotion/product/listing/',slide.rule_id)">
                        View Products</a></button>

                <button class="add-deal " (click)="addDeal(slide.rule_id)"
                    *ngIf="slide?.is_selection_product == 0 && slide?.is_promotion_applied == 0">
                    <!-- <img class="deal-button-image" src="../../../../assets/images/deal.svg" alt=""> -->
                    Add Deal
                </button>
                <button class="add-deal deal-applied "
                    *ngIf="(slide?.is_selection_product == 0 && slide?.is_promotion_applied == 1) || (slide?.is_selection_product == 1 && slide?.is_promotion_applied == 1)">
                    <img class="deal-button-image" src="../../../../assets/images/deal.svg" alt="">
                    Deal Added
                    <span
                        *ngIf="slide?.is_selection_product == 1 && slide?.is_promotion_applied == 1">{{slide?.promotion_applied_count}}</span>
                </button>

                <ngx-number-spinner id="spinerbtn_{{slide.rule_id}}" [value]="slide?.promotion_applied_count" [min]="0"
                    class="spinner" *ngIf="slide?.is_selection_product == 0 && slide?.is_promotion_applied == 1"
                    (change)="onChangePromotionCount(slide,$event,removeFreePdtTemplate,i)">
                </ngx-number-spinner>

            </div>
        </div>
    </ngx-slick-carousel>
</div>

<ng-template #removeFreePdtTemplate>
    <div class="modal-header border-0 pb-2">
        <h4 class="modal-title">Remove Deal</h4>
        <button type="button" class="close  " aria-label="Close"
            (click)="onPromotionRemovalCancel(modalService.config.initialState)">
            <span aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                    <g fill="none" fill-rule="evenodd">
                        <g stroke="#9B9B9B" stroke-width="1.75">
                            <g>
                                <g>
                                    <path d="M14 0L0 14M0 0L14 14"
                                        transform="translate(-1190 -462) translate(695 443) translate(496 20)" />
                                </g>
                            </g>
                        </g>
                    </g>
                </svg></span>
        </button>
    </div>
    <div class="modal-body py-0 px-0">
        <div class="row">
            <div class="col-md-12">
                <div class="text-center">
                    <p>Entire deal ( all products quantites ) will be removed.<br /> Are you sure you want to proceed?
                    </p>
                </div>
                <div class="button-div text-center mt-3">
                    <button class="common-button mr-3"
                        (click)="onPromotionRemovalCancel(modalService.config.initialState)">Cancel</button>
                    <button class="common-button ghost" (click)="removeDeal(modalService.config.initialState,true)">Yes,
                        Remove</button>
                </div>
            </div>
        </div>
    </div>
</ng-template>